// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"45985219","213":"ede2cc13","578":"d6ce6297","667":"4ff75127"}[chunkId] + ".chunk.js";
};